// extracted by mini-css-extract-plugin
export default {"box":"index_box__RcozF","backBtn":"index_backBtn__0O8+c","content":"index_content__MusI1","subTitle":"index_subTitle__XEStt"};